import React, { useState, useEffect, useContext } from "react";
import DataTable from 'react-data-table-component';
import './joblist.scss';
import { LuEye, LuTrash2, LuSearch, LuPencil } from "react-icons/lu";
import { JobForm } from "../../components/JobForm/JobForm";
import { IoCalendarOutline } from "react-icons/io5";
import jobApi from "../../services/jobApi";
import { getPriorityName, getJobStatusName } from "../../utils/common"
import { AuthContext } from "../../context/AuthContext";
import { useHeaderTitle } from '../../components/layout/layout';
import { JobDetailStatusEnum, JobDetailStatusEnumLabels } from "../../enum/enum";
import { useNavigate } from "react-router-dom";
import { FunctionalityNames } from "../../enum/enum";
import { getPermissionRights, getPermissionRightsForMenu } from "../../utils/common";
import { toast } from 'react-toastify';
import { ThreeDotLoader } from "../../components/Loader/Loader";
import { OverviewCount } from "../dashboard/overviewcount";

export default function JobList() {

    const REACT_APP_SEARCH_TEXT_LIMIT = process.env.REACT_APP_SEARCH_TEXT_LIMIT;
    const { rolePermissions } = useContext(AuthContext);
    const [isLoading, setIsLoading] = useState(false); // Loader state
    const [jobListPerm, setJobListPerm] = useState({});
    const [jobPostPerm, setJobPostPerm] = useState({});

    const { setHeaderTitle } = useHeaderTitle();
    const [isPopupupVisible, setIsPopupupVisible] = useState(false);
    const [jobList, setJobList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalRecords, setTotalRecords] = useState(10);
    const [totalPages, setTotalPage] = useState(10);
    const [searchText, setSearchText] = useState("");
    const { accountFilterValue, setAccountFilterValue } = useContext(AuthContext);
    const { departmentFilterValue, setDepartmentFilterValue } = useContext(AuthContext);
    const { countryFilterValue, setCountryFilterValue } = useContext(AuthContext);
    const { yearFilterValue, setYearFilterValue } = useContext(AuthContext);
    const [editingRowId, setEditingRowId] = useState();
    const [statusFilterValue, setStatusFilterValue] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [mentionedFilter, setMentionedFilter] = useState(""); // "" (All), "1" (Me), "2" (Team)

    const columns = [
        {
            name: 'Job Title',
            selector: (row) => row.jobTitle,
            selector: (row) => row.jobCode,
            //selector: (row) => new Date(row.createdAt).toLocaleDateString('en-US'),
            cell: (row) => (
                <div className="job-details">
                    <h6>{row.jobTitle}</h6>
                    <div className="d-flex gap-3 align-items-center">
                        <p className="mb-0">Job ID: <strong> {row.jobCode} </strong></p>
                        <span className="fst-italic"><IoCalendarOutline /> {new Date(row.createdAt).toLocaleDateString('en-US')}</span>
                    </div>
                </div>
            ),
            width: "250px",

        },
        {
            name: 'Created by',
            selector: (row) => row.firstName + row.lastName
        },
        {
            name: 'No. of Positions',
            selector: (row) => row.numberOfPositions
        },
        {
            name: 'Account',
            selector: (row) => row.accountName
        },
        {
            name: 'Department',
            selector: (row) => row.departmentName
        },
        // {
        //     name: 'Company-Country',
        //     selector: (row) => row.companyDetails,
        //     cell: (row) => (
        //         <div title={`${row.companyDetails}`}>
        //             {`${row.companyDetails}`}
        //         </div>
        //     ), // Adds a tooltip with the full details
        // },
        {
            name: 'Priority',
            selector: (row) => getPriorityName(row.priority)
        },
        {
            name: 'Status',
            selector: (row) => getJobStatusName(row.jobStatus),
            cell: (row) => (
                <div className="status-count-holder">
                    <div
                        className={`status ${row.jobStatus === 'open'
                            ? 'primary'
                            : row.jobStatus === 'closed'
                                ? 'green'
                                : row.jobStatus === 'onhold'
                                    ? 'red'
                                    : 'dark'
                            }`}
                        title={row.jobStatus}
                    >
                        {getJobStatusName(row.jobStatus)}

                    </div>
                    <span>
                        {row?.statusDayCount || 0} Day(s)</span>
                </div>


            )
        },
        {
    name: "Action",
    width: "150px",
    button: true,
    right: true,
    cell: (row) => (
        <div className="gridIcons d-flex gap-2 justify-content-center pe-5" data-tag="allowRowEvents">
            {jobPostPerm?.create === 1 && (
                <button
                    type="button"
                    className="btn plain-btn-primary view-btn secondary-color"
                    title="Edit"
                    onClick={() => handleEditClick(row)}
                >
                    <LuPencil />
                </button>
            )}
            <button
                type="button"
                className="btn plain-btn-primary view-btn primary-color"
                title="Details"
                onClick={() => goToJobDetails(row)}
            >
                <LuEye />
            </button>
            {/* ...delete button if needed... */}
        </div>
    ),
},
    ];
    const navigate = useNavigate();
    const goToJobDetails = (item) => {
        navigate(`/job-list/job-details/${item.jobDetailId}`, { state: { item } });
    };

    const showPopup = () => {
        setIsPopupupVisible(true);
    };

    const hidePopup = () => {
        setEditingRowId(null);
        setIsPopupupVisible(false);
    };
    const fetchData = async (page, searchtxt, mentioned = mentionedFilter) => {
        setIsLoading(true); // Start loader
        try {
            //console.log(accountFilterValue);
            let queryString = `?pageIndex=${page}&pageLimit=${rowsPerPage}&searchText=${searchtxt}`;
            if (departmentFilterValue && departmentFilterValue > 0) {
                queryString += `&departmentId=${departmentFilterValue}`;
            }
            if (accountFilterValue && accountFilterValue > 0) {
                queryString += `&accountId=${accountFilterValue}`;
            }
            if (yearFilterValue && yearFilterValue > 0) {
                queryString += `&year=${yearFilterValue}`;
            }
            if (countryFilterValue && countryFilterValue > 0) {
                queryString += `&country=${countryFilterValue}`;
            }
            if (statusFilterValue && statusFilterValue !== "Status") {
                queryString += `&jobstatus=${statusFilterValue}`;
            }
            if (mentioned && mentioned !== "") {
                queryString += `&mentioned=${mentioned}`;
                // if (mentioned === "1") {
                //     queryString += `&mentioned=${mentioned}`;
                // }
            }

            console.log(queryString);
            const response = await jobApi.getAllJobDetails(queryString)
            let jobList = response?.data;
            //console.log(response?.data);
            setJobList(jobList)
            let totalRecordsCount = jobList?.[0]?.totalRecords || 0
            setTotalRecords(totalRecordsCount);
            //alert(totalRecordsCount/rowsPerPage)
            setTotalPage(Math.ceil(totalRecordsCount / rowsPerPage));
            //console.log(totalPages)

        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false); // Start loader
        }
    };

// Handler for Mentioned filter
    const handleMentionedFilter = (selectedValue) => {
        debugger
        setMentionedFilter(selectedValue);
        setCurrentPage(1);
        fetchData(1, searchText, selectedValue);
    };

    useEffect(() => {
        setHeaderTitle("Job List");
        fetchData(currentPage, searchText, mentionedFilter);
        realoadData();
    }, [
        accountFilterValue,
        departmentFilterValue,
        yearFilterValue,
        countryFilterValue,
        isPopupupVisible,
        setHeaderTitle,
        statusFilterValue,
        rowsPerPage,
        mentionedFilter // add this
    ]);

    // Handlers for pagination
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, searchText);
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        setRowsPerPage(rowsPerPage);
        setCurrentPage(1); // Reset to page 1 when rows per page changes
        fetchData(currentPage, searchText);
    };
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && (searchText.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || searchText.trim().length == 0)) {
            fetchData(currentPage, searchText);
        }
    };
    const handleInputChange = (e) => {
        const value = e.target.value;
        setSearchText(value);
        if (value.trim().length >= REACT_APP_SEARCH_TEXT_LIMIT || value.trim().length === 0) {
            fetchData(currentPage, value); // or just fetchData(value) if page doesn't matter
        }
    };

    const handleStatusFilter = (selectedValue) => {
        setStatusFilterValue(selectedValue);
        //console.log("Selected Job Status:", selectedValue);
        //fetchData(currentPage, searchText);
    };
    // Handle search button click
    const handleSearch = () => {
        console.log("Searching for:", searchText); // Replace with actual search logic
        fetchData(currentPage, searchText);
    };
    const handleDeleteClick = async (item) => {
        const userConfirmed = window.confirm("Are you sure you want to delete this item?");
        if (userConfirmed) {
            const response = await jobApi.deleteJobDetails(item.jobDetailId);
            console.log(response);
            if (response?.ok) {
                fetchData(currentPage, searchText);
                // alert(response?.message);
                toast.success(response?.message, {
                    position: "top-right",
                    autoClose: 2000,
                });
            }
            else {
                toast.error("Something went wrong", {
                    position: "top-right",
                    autoClose: 2000,
                });
            }
        }
    };
    const handleEditClick = async (item) => {
        //alert(item.jobDetailId);
        setEditingRowId(item.jobDetailId);
        showPopup();
    };
    useEffect(() => {
        if (rolePermissions) {
            setJobListPerm(getPermissionRights(rolePermissions, FunctionalityNames.JOBLIST));
            setJobPostPerm(getPermissionRights(rolePermissions, FunctionalityNames.YEARLY));
        }
    }, [rolePermissions]);

    const realoadData = () => {
        setRefresh(preVal => !preVal);
    };


    return jobListPerm?.view === 1 && (
        <section>
            {isLoading && <ThreeDotLoader />} {/* Loader overlay */}
            <div className="alert-wrapper position-fixed">
                {/* you can use any of fllowing type as per need */}
                {/* <div className="alert alert-primary alert-dismissible fade show" role="alert">
                <div className="alert alert-secondary alert-dismissible fade show" role="alert">
                <div className="alert alert-success alert-dismissible fade show" role="alert">
                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <div className="alert alert-warning alert-dismissible fade show" role="alert">
                <div className="alert alert-info alert-dismissible fade show" role="alert">
                <div className="alert alert-dark alert-dismissible fade show" role="alert"> */}

                {/* <div className="alert alert-light alert-dismissible fade show" role="alert">
                    <strong>Holy guacamole!</strong> You should check in on some of those fields below.
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div> */}
            </div>

            <section>
                <OverviewCount refresh={refresh} />
            </section>
            <section className="tool-bar d-flex align-items-center mb-3 gap-3 flex-wrap">
                <div>
                    <div className="d-flex gap-3 align-items-center flex-wrap">
                        <div>
                            <label className="form-label d-block mb-0" >Filter by Status</label>
                            <select
                                className="form-select w-180"
                                aria-label="account"
                                onChange={(event) => handleStatusFilter(event.target.value)}
                            >
                                {/* <option value="">Status</option> */}
                                <option value="">All</option>
                                {Object.keys(JobDetailStatusEnum).map((key) => (
                                    <option key={key} value={JobDetailStatusEnum[key]}>
                                        {JobDetailStatusEnumLabels[JobDetailStatusEnum[key]]}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label className="form-label d-block mb-0" >Filter by Mentioned</label>
                            <select
                                className="form-select w-180"
                                aria-label="mentioned"
                                value={mentionedFilter}
                                onChange={e => handleMentionedFilter(e.target.value)}
                            >
                                <option value="">All</option>
                                <option value="1">Assign To Me</option>
                                <option value="2">Assign To Team</option>
                            </select>
                        </div>
                        {/* <div className="radio-group d-flex">
                            <div className="form-check form-check-inline d-flex align-items-center gap-2">
                                <input className="form-check-input" type="radio" name="AssignOptions" id="AssignToMe" value="option1" />
                                <label className="form-check-label" htmlFor="AssignToMe">Assign To Me</label>
                            </div>
                            <div className="form-check form-check-inline d-flex align-items-center gap-2">
                                <input className="form-check-input" type="radio" name="AssignOptions" id="AssignToTeam" value="option2" />
                                <label className="form-check-label" htmlFor="AssignToTeam">Assign To Team</label>
                            </div>
                        </div> */}

                    </div>
                </div>
                <div className="ms-auto">
                    <div className="d-flex gap-2 align-items-center">
                        <div className="input-group search-container">
                            {/* <input type="text" className="form-control" placeholder='Search' value={searchText}
                                onChange={(e) => setSearchText(e.target.value)} onKeyDown={handleKeyDown} />
                            <button type="button" className="btn plain-btn-secondary" onClick={handleSearch}><LuSearch /></button> */}
                            <input type="text" className="form-control" placeholder='Search' value={searchText}
                                // onChange={(e) => setSearchText(e.target.value)} onKeyDown={handleKeyDown} />
                                onChange={(e) => {
                                    setSearchText(e.target.value)
                                    fetchData(currentPage, e.target.value)
                                }} />
                            <button type="button" className="btn plain-btn-secondary" onClick={handleSearch}><LuSearch /></button>
                        </div>
                        {jobPostPerm?.create === 1 && (
                            <button type="button" className="btn btn-primary d-flex" onClick={showPopup}>Create Job</button>
                        )}
                    </div>
                </div>
            </section>
            <section className="datatable-holder">
                <DataTable
                    columns={columns}
                    data={jobList}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRecords}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    // progressPending={loading} // Show loader while fetching data
                    sortServer
                // pagination
                />
            </section>
            {isPopupupVisible && <JobForm closePopup={hidePopup} existingData={editingRowId} />}


        </section>

    );
}

